 
import { routes } from "../../../routers/routes";
import Breadcrumbs from "../../commonComponents/breadcrumbs";
import GridView from "../../commonComponents/gridView";

const JobLeftDrawerContainer = () => {
  return (
    <>
      <Breadcrumbs title="Job Listing" url={routes.Home.JobDemo1} mainClass="job-breadcrumbs-section" />
      <GridView type="job" sectionClass="job-grid-section" filterTagsClass="job-list-header" side="no" gridSize={3} carShow={9} />
    </>
  );
};

export default JobLeftDrawerContainer;
